import styled from 'styled-components'

export const ColorOptions = styled.div`

`
export const ColorNavTabs = styled.div`
  display: flex;
  background: #F7F5F5;
  border: 1px solid #D0D0D0;
  border-radius: 40px;
  padding: 2px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  @media(min-width: 1200px) {
	margin-bottom: 30px;	
  }
`

export const ColorNavitem = styled.div`
  position: relative;
  background: ${props => (props.active === "true" ? "#ffffff" : "#F7F5F5")};
  color: ${props => (props.active === "true" ? "#E43D3C" : "#938888")};
  box-shadow: ${props => (props.active === "true" ? "0 0 30px rgba(0, 0, 0, .16)" : "none")};
  border-radius: 40px;
  font-size: 20px;
  line-height: 1;
  padding: 10px 20px;
  margin-left: ${props => props.ml};

  :hover {
    cursor: pointer;
  }

  @media(max-width: 480px) {
    font-size: 14px;
    padding: 10px 15px;
  }
`

export const ColorTabContent = styled.div`  
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin:0 -10px;

`
export const ColorItem = styled.div`	
	position:relative;
	width: 100%;	
	padding: 0 10px;
	margin-bottom: 30px;
	@media(min-width: 576px) {
		max-width:50%;
		flex:0 0 50%;
	}
	@media(min-width: 768px) {
		max-width:33.333333%;
		flex:0 0 33.333333%;
	}
	@media(min-width: 992px) {
		max-width:25%;
		flex:0 0 25%;
	}
`
export const Color = styled.div`	
	background: #ffffff;
	text-align: center;
	padding: 0 10px;
	.gatsby-image-wrapper, img {
		width: 100%;
		height: 40px;
	}
	p {
		padding:8px 0;
		margin-bottom: 0;
		font-size: 12px;
		line-height: 1;
		@media(min-width: 576px) {
			font-size: 14px;
		}
	}
`